import JwtStore from '../flux/JwtStore';
import getCurrentBrand from './getCurrentBrand';

function has(roles, name) {
  return roles.indexOf(name) !== -1;
}

function getRole(roles) {
  if (has(roles, 'DEFAULT')) return 'DEFAULT';
  if (has(roles, 'TEST')) return 'TEST';
  if (has(roles, 'ADMIN')) return 'ADMIN';
  if (has(roles, 'STORE_ASSISTANT')) return 'STORE_ASSISTANT';
  if (has(roles, 'STORE_MANAGER')) return 'STORE_MANAGER';
  if (has(roles, 'RETAIL_MANAGER')) return 'RETAIL_MANAGER';
  if (has(roles, 'CORPORATE')) return 'CORPORATE';
  if (has(roles, 'CRM_MANAGER')) return 'CRM_MANAGER';
  if (has(roles, 'LOCAL_EDITOR')) return 'LOCAL_EDITOR';
  if (has(roles, 'AREA_MANAGER')) return 'AREA_MANAGER';
  if (has(roles, 'OFFICE')) return 'OFFICE';
  if (has(roles, 'FUR_SPECIALIST')) return 'FUR_SPECIALIST';
  if (has(roles, 'WHOLESALE')) return 'WHOLESALE';

  // Order not approved from Valentino
  if (has(roles, 'FUR_SPECIALIST')) return 'FUR_SPECIALIST';
  if (has(roles, 'TRAINING_MANAGER')) return 'TRAINING_MANAGER';

  return undefined;
}

export default () => ({
  user_id: JwtStore.getUsername(),
  role: getRole(JwtStore.getRoles()),
  country: JwtStore.getCountries()[0],
  search: undefined, // with Adobe Analytics we must set it to undefined for default value
  region: JwtStore.getRegions()[0],
  stores: JwtStore.getStores().sort().join(','),
  brand: getCurrentBrand(),
  version: process.env.REACT_APP_APP_VERSION
});
